import React from 'react';
import PropTypes from 'prop-types';
import css from './RowButton.css';
import StyledButton from 'common/StyledButton';
import Icon from 'SF/MaterialIcon';
import ReactTooltip from 'react-tooltip';

function RowButton(props) {

  const onClick = () => {
    props.onClick();
    ReactTooltip.hide();
  };
  
  return (
    <>
      <StyledButton asLink onClick={onClick}>
        <Icon 
          icon={props.icon}
          data-tip={props.label}
          aria-label={props.label}
        />
      </StyledButton>
      <ReactTooltip
        className={css['tooltip']}
        multiline
        effect="solid"
        place="bottom"
      />
    </>
  );
}

RowButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export default RowButton;
